import { render, staticRenderFns } from "./CapturaDocumentosFormCovid.vue?vue&type=template&id=2b8942cc&scoped=true&"
import script from "./CapturaDocumentosFormCovid.vue?vue&type=script&lang=js&"
export * from "./CapturaDocumentosFormCovid.vue?vue&type=script&lang=js&"
import style0 from "./CapturaDocumentosFormCovid.vue?vue&type=style&index=0&id=2b8942cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8942cc",
  null
  
)

export default component.exports